export const counterId =
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod' ? '99822033' : '99821988'
